module.exports = __webpack_public_path__ + "img/5-4.f8fe7e9e.png";